<template>

    <div v-if="title" class="text-lg text-white font-light mb-12">
        Interactive/fun infographic questionnaire to help the determine whether the client needs/wants a home theater or a media room
    </div>

    <ul class="text-neutral-50 font-light mb-12">
        <li v-for="item in content_list" class="mb-8 flex items-center">
            <img class="mr-5 h-6" src="/images/list_marker.svg" alt="list_marker">
            <div>Bullet point bullet point bullet point bullet point</div>
        </li>
    </ul>

</template>

<script setup>

const props = defineProps({
    title: {
        type: Boolean,
        default: true,
    }
})

const content_list = [1,2,3,4,5,6,7,8]

</script>
